var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichDarkD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6082_16539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3925 12.0396L21.1925 12.0433C21.1939 11.7296 21.0119 11.444 20.7268 11.3129C20.4418 11.1817 20.1064 11.2293 19.8691 11.4346L20.3925 12.0396ZM11.9027 3.60791L12.5113 4.12711C12.7149 3.88843 12.7602 3.55277 12.6272 3.26865C12.4941 2.98453 12.2073 2.8044 11.8936 2.80796L11.9027 3.60791ZM19.8691 11.4346C18.9571 12.2234 17.7698 12.6998 16.4693 12.6998V14.2998C18.1686 14.2998 19.7241 13.6755 20.9158 12.6447L19.8691 11.4346ZM16.4693 12.6998C13.5974 12.6998 11.2693 10.3717 11.2693 7.49983H9.66931C9.66931 11.2554 12.7138 14.2998 16.4693 14.2998V12.6998ZM11.2693 7.49983C11.2693 6.21211 11.7364 5.03551 12.5113 4.12711L11.294 3.08871C10.2814 4.27577 9.66931 5.81734 9.66931 7.49983H11.2693ZM4.40742 11.9999C4.40742 7.83611 7.75925 4.45505 11.9117 4.40786L11.8936 2.80796C6.86557 2.86511 2.80742 6.95855 2.80742 11.9999H4.40742ZM12 19.5925C7.80674 19.5925 4.40742 16.1932 4.40742 11.9999H2.80742C2.80742 17.0769 6.92308 21.1925 12 21.1925V19.5925ZM19.5925 12.0359C19.5731 16.2126 16.1813 19.5925 12 19.5925V21.1925C17.0624 21.1925 21.1691 17.1003 21.1925 12.0433L19.5925 12.0359Z",
    fill: "#c0d2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 6.94971L16.9306 6.42673L14.4995 9.90377L17.4536 9.3808",
    stroke: "#c0d2f0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 2.14111L22.1275 2.65514L18.6578 5.09675L21.6135 5.61077",
    stroke: "#c0d2f0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6082_16539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichDarkD);
export default __webpack_public_path__ + "static/media/rich-dark_d.08afca3283bf713736f66bff61f5ed67.svg";
export { ForwardRef as ReactComponent };